import { createSlice } from '@reduxjs/toolkit';
import { set } from 'date-fns';

const initialState = {
  userMarketplace: {},
  status: 'idle',
  error: null,

  // table number
  tableNumber: null,
  manuallySet: false,

  // retailer id
  retailerId: null,

  // Shopping cart
  shoppingCart: {},
  cartStatus: 'idle',
  updateCartStatus: 'idle',
  cartError: null,


  // user info
  userName: null,
  userEmail: null,
  nameStatus: 'idle',
  emailStatus: 'idle',
  nameError: null,
  emailError: null,


  // delivery method
  deliveryMethod: null,

  //pin
  pin: null,

  // order comments
  comment: '',

  // total fee including stripe fees
  totalFee: 0,
};

const retailerMarketplaceSlice = createSlice({
  name: 'userMarketplace',
  initialState,
  reducers: {
    reset: (state) => {
      state.shoppingCart = {};
      state.cartStatus = 'idle';
      state.updateCartStatus = 'idle';
      state.cartError = null;
      state.status = 'idle';
      state.tableNumber = null;
      state.userName = null;
      state.userEmail = null;
      state.nameStatus = 'idle';
      state.emailStatus = 'idle';
      state.nameError = null;
      state.emailError = null;
      state.deliveryMethod = null;
      state.manuallySet = false;
      state.pin = null;
      state.retailerId = null;
      state.totalFee = 0;
    },
    resetShoppingCart: (state) => {
      state.shoppingCart = {};
    },
    setShoppingCart: (state, action) => {
      state.shoppingCart = action.payload;
    },
    setTableNumber: (state, action) => {
      state.tableNumber = action.payload;
    },
    setRetailerId: (state, action) => {
      state.retailerId = action.payload;
    },
    setUserName: (state, action) => {
      state.userName = action.payload;
    },
    setUserEmail: (state, action) => {
      state.userEmail = action.payload;
    },
    setDeliveryMethod: (state, action) => {
      state.deliveryMethod = action.payload;
    },
    setManuallySet: (state, action) => {
      state.manuallySet = action.payload;
    },
    setPin: (state, action) => {
      state.pin = action.payload
    },
    setTotalFee: (state, action) => {
      state.totalFee = action.payload;
    },
    removeFromCart: (state, action) => {
      delete state.shoppingCart[action.payload];
    }
  },
  extraReducers: {},
});


export const selectDeliveryMethod = (state) => state.userMarketplace.deliveryMethod;
export const selectRetailerId = (state) => state.userMarketplace.retailerId;

// user info
export const selectUserName = (state) => state.userMarketplace.userName;
export const selectUserEmail = (state) => state.userMarketplace.userEmail;
export const selectUserNameStatus = (state) => state.userMarketplace.nameStatus;
export const selectUserEmailStatus = (state) => state.userMarketplace.emailStatus;

// table
export const selectManuallySet = (state) => state.userMarketplace.manuallySet;
export const selectTableNumber = (state) => state.userMarketplace.tableNumber;

// shopping cart
export const selectShoppingCartStatus = (state) => state.userMarketplace.cartStatus;
export const selectUpdateCartStatus = (state) => state.userMarketplace.updateCartStatus;
export const selectShoppingCart = (state) => state.userMarketplace.shoppingCart;

// total fee including stripe fees
export const selectTotalFee = (state) => state.userMarketplace.totalFee;

// calculate price of all items in the shopping cart
export const selectShoppingCartPrice = (state) => {

  let items = Object.keys(state.userMarketplace.shoppingCart);
  let totalPrice = 0;

  if (items.length === 0) {
    return 0;
  }
  else {
    items.forEach((item) => {
      const product = state.userMarketplace.shoppingCart[item];
      if (product && product.price && product.quantity) {
        totalPrice += product.price * (product.quantity || 1);
      }
    });
  }

  // make total price in cents
  //return Math.round(totalPrice * 100);
  return totalPrice;

}

// generate random pin
export const generatePin = () => {
  const pin = Math.floor(1000 + Math.random() * 9000);
  return pin;
}

export const selectPin = (state) => state.userMarketplace.pin;

export const { setTotalFee, reset, setRetailerId, setTableNumber, resetShoppingCart, setShoppingCart, setUserEmail, setUserName, setDeliveryMethod, setManuallySet, setPin, removeFromCart } = retailerMarketplaceSlice.actions;

export default retailerMarketplaceSlice.reducer;
